import { Notifications } from "@mantine/notifications";
import { captureException, ErrorBoundary } from "@sentry/react";
import { Provider } from "react-redux";
import { Outlet } from "react-router-dom";
import ThemeWrapper from "src/components/shared/ThemeWrapper/ThemeWrapper";
import PlainErrorFallback from "src/components/shared/PlainErrorFallback/PlainErrorFallback";
import UpdateBlocker from "src/components/shared/UpdateBlocker/UpdateBlocker";
import ErrorPage from "src/pages/ErrorPage";
import { store } from "src/redux/store";
import ScrollToTop from "src/ScrollToTop";

import { useTimezoneWatcher } from "../generator/hooks/useTimezoneWatcher";
import { useLiveChat } from "./hooks";

const AppProvider = () => {
  useLiveChat();
  useTimezoneWatcher();
  const handleError = (error: unknown) => {
    captureException(error);
  };

  return (
    <ErrorBoundary fallback={<PlainErrorFallback />} onError={handleError}>
      <Provider store={store}>
        <ThemeWrapper>
          <ErrorBoundary fallback={<ErrorPage />} onError={handleError}>
            <Notifications position="bottom-left" />
            <UpdateBlocker />
            <div className="app-container">
              <Outlet />
            </div>
            <ScrollToTop />
          </ErrorBoundary>
        </ThemeWrapper>
      </Provider>
    </ErrorBoundary>
  );
};

export default AppProvider;
